
/*
    dates
*/
export function getDateForPicker(date) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return date.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;//Y-m-d
}

export function formatTime(date) {
    return date.toLocaleTimeString("nl-NL", {hour: "2-digit", minute: "2-digit"});
}

export function formatDate(date) {
    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
}

export function areDatesEqual(date1, date2) {
    if (date1 === null || date2 === null) {
        return false;
    }
    if (typeof date1 === "string") {
        date1 = newDateFromString(date1);
    }
    if (typeof date2 === "string") {
        date2 = newDateFromString(date2);
    }
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
}

export function newDateFromString(dateString) {
    if (dateString === null) {
        return null;
    }
    return new Date(Date.parse(dateString.replace(/\s+/g, "T"))); //add T to fix date parse on safari
}

export function isLaterThan(timeString, minutesOffset) { //13:26
    const d = new Date();
    const minutes = 60 * d.getHours() + d.getMinutes();

    const timeArr = timeString.split(":").map(x => parseInt(x));
    return timeArr[0] * 60 + timeArr[1] > minutes - minutesOffset;
}

export function getSlotFromDate(date) {
    const d = newDateFromString(date);
    const mins = d.getMinutes();
    const hours = d.getHours();
    return (hours < 10 ? "0" : "") + hours + ":" + (mins < 10 ? "0" : "") + mins;
}

export function currentTimestamp() {
    return Math.round(Date.now() / 1000);
}

export function mysqlDate(date) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return date.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
}

export function isValidDate(date) {
    return date instanceof Date && !isNaN(date);
}

//return 0:ma, 1:di, 2:wo enz
export function getWeekDay(date) {
    const day = date.getDay(); //zondag is 0, maandag is 1
    if (day === 0) {
        return 6;
    }
    return day - 1;
}

/*
    pwa
*/
export function isPWA() {
    return window.matchMedia("(display-mode: standalone)").matches;
}

export function isMobile() {
    let agents = ["android", "ipad", "iphone"];
    for (const agent of agents) {
        if (navigator.appVersion.toLowerCase().indexOf(agent) > -1) {
            return true;
        }
    }
    return false;
}

/*
    objects / arrays
*/
export function deepCopyArray(arr) {
    return arr.map(a => Object.assign({}, a));
}
export function replaceObjectInArray(arr, obj) {
    return [...arr.filter(x => x.id !== obj.id), obj];
}

export function mergeArrays(arr1, arr2) {
    const ids = arr2.map(x => x.id);
    return [...arr1.filter(x => ids.indexOf(x.id) === -1), ...arr2];
}

export function removeObjectFromArray(arr, obj) {
    return arr.filter(x => x.id !== obj.id);
}

export function deepCopyObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function fillArrayWithFromTo(from, to) {
    return [...Array(to - from + 1).keys()].map(x => x + from);
}

/*
    math
*/
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

/*
    project specific
*/
export function isValidEmail(email) {
    return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,20})+$/.test(email));
}

export function formatSalesName(sales) {
    if (sales === null) {
        return "";
    }
    return ((sales.firstname.length > 0 ? sales.firstname[0] : "") + (sales.lastname.length > 1 ? sales.lastname[0] : "")).toUpperCase();
}

export function formatAppointmentNames(appointment) {
    return appointment.clients.map(x => x.firstname + " " + x.lastname).join(" & ");
}

export function getFullSleepDnaFromMeasurement(baseLevels) {
    const values = 13;
    let result = [];
    for (const baseLevel of baseLevels) {
        let dna = [];

        for (let i = 1; i <= values; i++) {
            dna.push({
                value : baseLevel["L" + i],
                strength : baseLevel["Strength" + i],
                fixed : baseLevel["Fixed" + i]
            });
        }
        result.push({
            baseType : baseLevel["BaseType"].trim(),
            dna
        });
    }

    return result;
}

export function getSleepDnaFromMeasurement(baseLevels) {
    const bs4Level = getFullSleepDnaFromMeasurement(baseLevels).find(x => x.baseType === "BS4");
    if (bs4Level !== undefined) {
        return bs4Level.dna.map(x => x.value);
    }
    return [];
}
